import React from "react";
import Toggle from "react-toggle";
import { Tooltip as ReactTooltip } from "react-tooltip";

const ToggleInput = ({ tooltipId, tooltipContent = '', ...rest }: any) => {
  return (
    <>
      <div data-tooltip-id={tooltipId}>
        <Toggle
          {...rest}
          icons={{
            unchecked: null,
            checked: null,
          }}
        />
      </div>
      {tooltipId === 'my-tooltip-1' && <ReactTooltip
        id="my-tooltip-1"
        place="bottom"
        content={tooltipContent}
      />}
      {tooltipId === 'my-tooltip-2' && <ReactTooltip
        id="my-tooltip-2"
        place="bottom"
        content={tooltipContent}
      />}
    </>
  );
};

export default ToggleInput;
